$(document).ready(function() {
  // Open the Yotpo drawer with custom button
  $('#open-reviews').click(function(e) {
    e.preventDefault();
    $('.yotpo-reviews-tab-floating-tab').click(); // Trigger the Yotpo drawer open
  });

  // Function to force-close any lingering Yotpo instances
  function forceCloseYotpoDrawer() {
    const yotpoDrawer = $('#yotpo-app');
    if (yotpoDrawer.is(':visible')) {
      yotpoDrawer.hide(); // Hide the visible Yotpo drawer
    }
  }

  // Detect clicks on the original Yotpo close button to force-close lingering instances
  $(document).on('click', '.yotpo-reviews-tab-floating-tab', function() {
    // Small delay to ensure Yotpo's close action completes before forcing close
    setTimeout(forceCloseYotpoDrawer, 500);
  });
});
